import { useContext } from 'react';
import Sections from '~/constants/vdp/sections';
import GlobalContext from '~/context/vdp/GlobalContext';
import { useSectionViewed } from '~/context/vdp/UiContext';
import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';
import useGetShouldRenderBelowSpinner from './useGetShouldRenderBelowSpinner';

export default function useShouldLoadFirstSection() {
  const shouldRenderBelowSpinner = useGetShouldRenderBelowSpinner();
  const { isLazyLoadEnabled } = useContext(GlobalContext);
  const isWip = useGetIsWIPVehicle();
  const wasGalleryViewed = useSectionViewed(Sections.Gallery);

  return (
    shouldRenderBelowSpinner &&
    (!isLazyLoadEnabled || wasGalleryViewed || isWip)
  );
}
